import React from 'react';
import { XIcon, CheckIcon, ArrowDownIcon } from 'lucide-react';
import { SectionShell } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { withDeck, withoutDeck } from '../../data/content';
const flow = ['QUESTION', 'CARD', 'CONTEXT', 'PATHWAY', 'NEXT REVIEW'];
export function BeforeAfter() {
  return <SectionShell tone="darker" data-id="element-87" data-mp="22m2ddegjhtwj">
      <header className="mb-8 text-center" data-id="element-88" data-mp="22iy3c0ge83xy">
        <h2 className="font-display text-xl uppercase leading-tight text-sky-100/60 sm:text-2xl" data-id="element-89" data-mp="2zba3z0w0mt7b">
          From a TRT consultation full of information…
        </h2>
        <ArrowDownIcon className="mx-auto my-2 h-6 w-6 text-sky-400" aria-hidden="true" data-id="element-90" data-mp="2qabuw46pzvhv" />
        <p className="font-display text-2xl uppercase leading-tight text-white sm:text-4xl" data-id="element-91" data-mp="2qc6kvwwumdst">
          To a clear decision pathway
        </p>
      </header>

      <div className="grid gap-4 md:grid-cols-2" data-id="element-92" data-mp="1evyaxaf38074">
        <div className="rounded-2xl border border-alert/30 bg-navy-900 p-5" data-id="element-93" data-mp="19w3mddisbmp8">
          <h3 className="mb-4 flex items-center gap-2 font-display text-base uppercase text-alert sm:text-lg" data-id="element-94" data-mp="19y6notpe1299">
            <XIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-95" data-mp="173jc6dr43b6b" />
            Without the deck
          </h3>
          <ul className="space-y-3" data-id="element-96" data-mp="y4y091g5auei">
            {withoutDeck.map(item => <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-sky-100/70" data-id="element-97" data-mp="y70n5cm047f0">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-98" data-mp="135lppioq736m" />
                <span data-id="element-99" data-mp="ocrwyvkg0qk0">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border border-emerald-400/30 bg-navy-800 p-5" data-id="element-100" data-mp="t6w8zt8kfory">
          <h3 className="mb-4 flex items-center gap-2 font-display text-base uppercase text-emerald-400 sm:text-lg" data-id="element-101" data-mp="ffrdn3c8dinf">
            <CheckIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-102" data-mp="jdp4ealngcsx" />
            With the deck
          </h3>
          <ul className="space-y-3" data-id="element-103" data-mp="5iczxbhoz7yt">
            {withDeck.map(item => <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-white" data-id="element-104" data-mp="aebr16uen42x">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-105" data-mp="2c5u1u3v4a4d2" />
                <span data-id="element-106" data-mp="27bzjp4v5txg3">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <ul className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-107" data-mp="23c79knq4bj8m">
        {flow.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-108" data-mp="1yb1hms4a8005" data-mpi={index}>
            <span className="rounded-md bg-navy-700 px-2.5 py-1.5 font-display text-[11px] uppercase tracking-wide text-sky-200 sm:text-xs" data-id="element-109" data-mp="2v1tuzhztzdy8">
              {step}
            </span>
            {index < flow.length - 1 && <span className="text-sky-400" aria-hidden="true" data-id="element-110" data-mp="2m4jla12nvwvf">
                →
              </span>}
          </li>)}
      </ul>

      <div className="mt-8" data-id="element-111" data-mp="1anju58s1vo2z">
        <CTAButton label="I want a visual TRT decision system" subline="One-time payment · $27 · Instant access" data-id="element-112" data-mp="1aouwd45uknrz" />
      </div>
    </SectionShell>;
}